document.addEventListener('DOMContentLoaded', () => {
    // Project entry point.
})
